export function getData(spectra) {
    const x = spectra[0]?.data?.x || [];
    const re = spectra[0]?.data?.re || spectra[0]?.data?.y || [];
    const im = spectra[0]?.data?.im || spectra[1]?.data?.y || null;
    if (x.length > 0 && x[0] > x[1]) {
        x.reverse();
        re.reverse();
        if (im)
            im.reverse();
    }
    return { x, re, im };
}
//# sourceMappingURL=getData.js.map